import React from 'react';
export var defaultSiteMenuBarConfig = {};
export var SiteMenuBarContext = React.createContext(defaultSiteMenuBarConfig);
export var SiteMenuBarProvider = SiteMenuBarContext.Provider;